import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { BookingPriceCardComponent } from "./booking-price-card.component";
import { CardModule } from "libraries/ui_card/card.module";
import { MenuDetailsModule } from "libraries/hotel/components/menu-details/menu-details.module";
import { BookingPriceCardServiceModule } from "./booking-price-card-service.module";
import { PriceTabModule } from "./components/price-tab/price-tab.module";
import { TravellersMapperService } from './mappers/travellers-mapper.service';
import { PriceMapperService } from './mappers/price-mapper.service';
import { KeysMapperService } from './mappers/keys-mapper.service';
import { ConfigurationResourceModule } from "libraries/service/resources/configuration/configurationResource.module";
import { ConditionsTabModule } from './components/conditions-tab/conditions-tab.module';
import { StayPriceTabModule } from "./components/stay-price-tab/stay-price-tab.module";
import { SectorModule } from "libraries/service/sector/sector.module";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { VehicleRentalPriceTabModule } from "./components/vehicle-rental-price-tab/vehicle-rental-price-tab.module";
import { PricesTableComponent } from './components/prices-table/prices-table.component';
import { MatTableModule } from "@angular/material/table";
import { PricesTableService } from "./services/prices-table.service";
import { ComputeRatePipe } from './pipes/compute-rate.pipe';
import { BookingIconModule } from "libraries/pipes/type-of/booking-icon.module";
import { RateSectorsComponent } from './components/rate-sectors/rate-sectors.component';
import { BookingSectorsModule } from "../../../booking-sectors/booking-sectors.module";
import {
    TableSectorAirSummaryModule
} from "./components/shared/components/table-sector-air-summary/table-sector-air-summary.module";
import { ComputeTravellerTitlePipe } from "./pipes/compute-traveller-title.pipe";
import { PricePipesModule } from "../../../../pipes/price/price-pipes.module";
import {
    SectorsAirSummaryWithRuptureModule
} from "./components/sectors-air-summary-with-rupture/sectors-air-summary-with-rupture.module";
import { SectorsAirSimpleListModule } from "../../../sectors-air-simple-list/sectors-air-simple-list.module";
import { PricesSummaryComponent } from './components/prices-summary/prices-summary.component';
import { MultiselectModule } from "libraries/module/formbuilder/fields/multiselect/multiselect.module";
import {
    PriceTableModule
} from "libraries/component/booking-information/components/booking-price-card/components/shared/components/price-table/price-table.module";
import {
    MenuDetailsTarificationsModule
} from "libraries/component/menu-details-tarifications/menu-details-tarifications.module";
import { ComputeRateIconPipe } from "./pipes/compute-rate-icon.pipe";
import { TarificationDetailsComponent } from './components/tarification-details/tarification-details.component';
import {
    TarificationDetailsTableComponent
} from './components/tarification-details-table/tarification-details-table.component';
import { ComputeRulePipe } from './pipes/compute-rule.pipe';
import { ComputeTravellerTypePipe } from "./pipes/compute-traveller-type.pipe";
import { TarificationsListComponent } from './components/tarifications-list/tarifications-list.component';
import {
    TarificationsHeaderComponent
} from "libraries/component/booking-information/components/booking-price-card/components/tarifications-header/tarifications-header.component";
import { PricePipeModule } from "../../../../pipes/price/price-pipe.module";
import {
    TarificationHeaderServiceComponent
} from "libraries/component/booking-information/components/booking-price-card/components/tarification-header-service/tarification-header-service.component";
import {
    SectorHeaderComponent
} from "libraries/component/booking-information/components/booking-price-card/components/sector-header/sector-header.component";
import {
    TarificationHeaderTransportationComponent
} from "libraries/component/booking-information/components/booking-price-card/components/tarification-header-transportation/tarification-header-transportation.component";
import { SectorDetailComponent } from './components/sector-detail/sector-detail.component';
import { ComputeOfferAndBookingValuePipe } from "./pipes/compute-offer-and-booking-value.pipe";
import { DisplayDifferenceComponent } from "./components/display-difference/display-difference.component";
import { FareOptimisationServiceModule } from "libraries/service/fare-optimisation/fare-optimisation-service.module";
import { LuggageUnitModule } from "./pipes/luggage-unit.module";
import { RouterModule } from "@angular/router";
import { MatCardModule } from "@angular/material/card";
import { BtnModule } from "libraries/ui_button/btn.module";



@NgModule({
    imports: [
        CardModule,
        CommonModule,
        ConditionsTabModule,
        ConfigurationResourceModule,
        MenuDetailsModule,
        PriceTabModule,
        StayPriceTabModule,
        SectorModule,
        FontAwesomeModule,
        BookingPriceCardServiceModule,
        VehicleRentalPriceTabModule,
        MatTableModule,
        BookingIconModule,
        BookingSectorsModule,
        TableSectorAirSummaryModule,
        PricePipesModule,
        SectorsAirSummaryWithRuptureModule,
        SectorsAirSimpleListModule,
        MultiselectModule,
        PriceTableModule,
        MenuDetailsTarificationsModule,
        PricePipeModule,
        CommonModule,
        FareOptimisationServiceModule,
        LuggageUnitModule,
        RouterModule,
        MatCardModule,
        BtnModule,

    ],
    exports: [
        BookingPriceCardComponent,
        TarificationsHeaderComponent,
        TarificationDetailsComponent,
        TarificationDetailsTableComponent,
    ],
    declarations: [
        BookingPriceCardComponent,
        PricesTableComponent,
        ComputeRatePipe,
        ComputeRateIconPipe,
        RateSectorsComponent,
        ComputeTravellerTitlePipe,
        ComputeTravellerTypePipe,
        PricesSummaryComponent,
        TarificationsListComponent,
        TarificationsHeaderComponent,
        TarificationHeaderServiceComponent,
        SectorHeaderComponent,
        TarificationHeaderTransportationComponent,
        TarificationDetailsComponent,
        TarificationDetailsTableComponent,
        ComputeRulePipe,
        SectorDetailComponent,
        ComputeOfferAndBookingValuePipe,
        DisplayDifferenceComponent,
    ],
    providers: [
        KeysMapperService,
        PriceMapperService,
        TravellersMapperService,
        PricesTableService,
        ComputeTravellerTitlePipe,
    ],
})
export class BookingPriceCardModule {
}
